import { ChangeEvent } from 'react'
import { Tabs as MuiTabs, styled } from '@mui/material'

export type PillTabsProps = {
    value: string | number
    onChange: (event: ChangeEvent<{}>, newValue: string) => void
}

const StyledTabs = styled(MuiTabs)(({ theme }) => ({
    minHeight: '4rem',
    height: '4rem',

    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '& > span': {
            backgroundColor: 'transparent',
            width: '100%',
        },
    },
}))

export const PillTabs = (props: PillTabsProps) => (
    <StyledTabs {...props} TabIndicatorProps={{ children: <span /> }} />
)
